/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  locale: 'fa',
  Pagination: {
    items_per_page: '/ صفحه',
    jump_to: 'برو به',
    jump_to_confirm: 'تایید',
    page: '',
    prev_page: 'صفحه قبلی',
    next_page: 'صفحه بعدی',
    prev_5: '۵ صفحه قبلی',
    next_5: '۵ صفحه بعدی',
    prev_3: '۳ صفحه قبلی',
    next_3: '۳ صفحه بعدی'
  },
  DatePicker: {
    lang: {
      placeholder: 'انتخاب تاریخ',
      rangePlaceholder: ['تاریخ شروع', 'تاریخ پایان'],
      locale: 'fa_IR',
      today: 'امروز',
      now: 'اکنون',
      backToToday: 'بازگشت به روز',
      ok: 'باشه',
      clear: 'پاک کردن',
      month: 'ماه',
      year: 'سال',
      timeSelect: 'انتخاب زمان',
      dateSelect: 'انتخاب تاریخ',
      monthSelect: 'یک ماه را انتخاب کنید',
      yearSelect: 'یک سال را انتخاب کنید',
      decadeSelect: 'یک دهه را انتخاب کنید',
      yearFormat: 'YYYY',
      dateFormat: 'M/D/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'M/D/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'ماه قبل (PageUp)',
      nextMonth: 'ماه بعد (PageDown)',
      previousYear: 'سال قبل (Control + left)',
      nextYear: 'سال بعد (Control + right)',
      previousDecade: 'دهه قبل',
      nextDecade: 'دهه بعد',
      previousCentury: 'قرن قبل',
      nextCentury: 'قرن بعد'
    },
    timePickerLocale: {
      placeholder: 'انتخاب زمان'
    }
  },
  TimePicker: {
    placeholder: 'انتخاب زمان'
  },
  Calendar: {
    lang: {
      placeholder: 'انتخاب تاریخ',
      rangePlaceholder: ['تاریخ شروع', 'تاریخ پایان'],
      locale: 'fa_IR',
      today: 'امروز',
      now: 'اکنون',
      backToToday: 'بازگشت به روز',
      ok: 'باشه',
      clear: 'پاک کردن',
      month: 'ماه',
      year: 'سال',
      timeSelect: 'انتخاب زمان',
      dateSelect: 'انتخاب تاریخ',
      monthSelect: 'یک ماه را انتخاب کنید',
      yearSelect: 'یک سال را انتخاب کنید',
      decadeSelect: 'یک دهه را انتخاب کنید',
      yearFormat: 'YYYY',
      dateFormat: 'M/D/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'M/D/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'ماه قبل (PageUp)',
      nextMonth: 'ماه بعد (PageDown)',
      previousYear: 'سال قبل (Control + left)',
      nextYear: 'سال بعد (Control + right)',
      previousDecade: 'دهه قبل',
      nextDecade: 'دهه بعد',
      previousCentury: 'قرن قبل',
      nextCentury: 'قرن بعد'
    },
    timePickerLocale: {
      placeholder: 'انتخاب زمان'
    }
  },
  Table: {
    filterTitle: 'منوی فیلتر',
    filterConfirm: 'تایید',
    filterReset: 'پاک کردن',
    selectAll: 'انتخاب صفحه‌ی کنونی',
    selectInvert: 'معکوس کردن انتخاب‌ها در صفحه ی کنونی',
    selectionAll: 'انتخاب همه داده‌ها',
    sortTitle: 'مرتب سازی',
    expand: 'باز شدن ردیف',
    collapse: 'بستن ردیف',
    triggerDesc: 'ترتیب نزولی',
    triggerAsc: 'ترتیب صعودی',
    cancelSort: 'لغوِ ترتیبِ داده شده'
  },
  Modal: {
    okText: 'تایید',
    cancelText: 'لغو',
    justOkText: 'تایید'
  },
  Popconfirm: {
    okText: 'تایید',
    cancelText: 'لغو'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'جستجو',
    itemUnit: '',
    itemsUnit: ''
  },
  Upload: {
    uploading: 'در حال آپلود...',
    removeFile: 'حذف فایل',
    uploadError: 'خطا در آپلود',
    previewFile: 'مشاهده‌ی فایل',
    downloadFile: 'دریافت فایل'
  },
  Empty: {
    description: 'داده‌ای موجود نیست'
  },
  Icon: {
    icon: 'آیکن'
  },
  Text: {
    edit: 'ویرایش',
    copy: 'کپس',
    copied: 'کپی شد',
    expand: 'توسعه'
  },
  PageHeader: {
    back: 'برگشت'
  },
  Form: {
    defaultValidateMessages: {
      default: 'خطا در ${label}',
      required: 'فیلد ${label} اجباریست',
      enum: '${label} باید یکی از [${enum}] باشد',
      whitespace: '${label} نمیتواند خالی باشد',
      date: {
        format: 'ساختار تاریخ در ${label} نامعتبر است',
        parse: '${label} قابل تبدیل به تاریخ نیست',
        invalid: '${label} تاریخی نا معتبر است'
      },
      types: {
        string: '${label} از نوع ${type} معتبر نیست',
        method: '${label} از نوع ${type} معتبر نیست',
        array: '${label} از نوع ${type} معتبر نیست',
        object: '${label} از نوع ${type} معتبر نیست',
        number: '${label} از نوع ${type} معتبر نیست',
        date: '${label} از نوع ${type} معتبر نیست',
        boolean: '${label} از نوع ${type} معتبر نیست',
        integer: '${label} از نوع ${type} معتبر نیست',
        float: '${label} از نوع ${type} معتبر نیست',
        regexp: '${label} از نوع ${type} معتبر نیست',
        email: '${label} از نوع ${type} معتبر نیست',
        url: '${label} از نوع ${type} معتبر نیست',
        hex: '${label} از نوع ${type} معتبر نیست'
      },
      string: {
        len: '${label} باید ${len} کاراکتر باشد',
        min: '${label} باید حداقل ${min} کاراکتر باشد',
        max: '${label} باید حداکثر ${max} کاراکتر باشد',
        range: '${label} باید بین ${min}-${max} کاراکتر باشد'
      },
      number: {
        len: '${label} باید برابر ${len}',
        min: '${label} حداقل میتواند ${min} باشد',
        max: '${label} حداکثر میتواند ${max} باشد',
        range: '${label} باید بین ${min}-${max} باشد'
      },
      array: {
        len: 'تعداد ${label} باید ${len} باشد.',
        min: 'تعداد ${lable} حداقل باید ${min} باشد',
        max: 'تعداد ${lable} حداکثر باید ${max} باشد',
        range: 'مقدار ${label} باید بین ${min}-${max} باشد'
      },
      pattern: {
        mismatch: 'الگوی ${label} با ${pattern} برابری نمی‌کند'
      }
    }
  }
};
